<template>
    <div class="p-fluid relative flex flex-column gap-1 custom-input-textarea relative">
        <CustomLabel :name="name" :label="label" :required="required"
                     :disabled="disabled"/>
        <Textarea :id="name" :rows="rows" :cols="cols" v-model="internalValue"
                  :class="computedClasses" @input="handleChange" @blur="handleBlur"
                  :disabled="disabled" />
        <CustomValidationMessage :errorMessage="customErrorMessage" />
    </div>
</template>

<script>
    import Textarea from "primevue/textarea";
    import {useField} from "vee-validate";
    import CustomLabel from "./inner/CustomLabel";
    import CustomValidationMessage from "./inner/CustomValidationMessage";

    export default {
        name: "CustomInputTextarea",

        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            width: {
                type: String,
            },
            rows: {
                type: Number,
                default: 5,
            },
            required: {
                type: Boolean,
                default: false,
            },
            rules: undefined,
            modelValue: null,
            disabled: {
                type: Boolean,
                default: false,
            },
            customErrorMessage: {
                type: String,
                default: "",
            },
            cols: {
                type: String,
                default: "30",
            },
        },
        emits: ["update:modelValue"],

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },

            computedClasses() {
                return this.errorMessage ? "p-invalid" : "";
            },
        },

        methods: {
            inputListener(event) {
                this.$emit("update:modelValue", event.target.value);
            },
        },

        setup(props) {
            const {
                value: inputValue,
                errorMessage,
                handleBlur,
                handleChange,
                meta,
            } = useField(props.name, props.rules, {
                initialValue: props.modelValue,
            });

            return {
                handleChange,
                handleBlur,
                errorMessage,
                inputValue,
                meta,
            };
        },

        components: {Textarea, CustomLabel, CustomValidationMessage},
    };
</script>

<style scoped>
    textarea {
        resize: none;
    }
</style>
